class ServiceError extends Error {
	constructor(message?: string, options?: ErrorOptions) {
		super(message, options)

		this.name = 'ServiceError'
	}
}

export default ServiceError
